var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ChalkyUtilityGallery',{staticClass:"view-venue-gallery venue-gallery",attrs:{"interactive":true,"model":_vm.venueModel},on:{"tap:small":_vm.Handle_OnTapGallery}})
}
var staticRenderFns = []

export { render, staticRenderFns }